<template>
  <vx-card title="Overview" collapse-action class="overflow-hidden">
    <div slot="no-body-bottom">
      <feather-icon
        :style="active ? 'margin-left: 350px' : 'margin-left:  9px'"
        style="
          position: absolute !important;
          z-index: 99;
          margin-top: 10px;
          background: white;
          height: 50px; /* text-align: center; */
          font-size: 41px;
          width: 50px;
          margin-left: 9px;
          border-radius: 68px;
        "
        class="mr-0 cursor-pointer"
        :icon="active ? 'ArrowLeftIcon' : 'ArrowRightIcon'"
        svg-classes="stroke-current text-primary"
        @click="active = !active"
      />
      <div class="mt-5" style="display: flex; justify-content: flex-end">
        <gmap-map
          ref="map"
          v-if="'col-lg'"
          :style="active ? 'width: 85%' : 'width:  100%'"
          map-type-id="roadmap"
          :options="{ mapTypeControl: false }"
          :center="center"
          :zoom="zooom"
          style="height: 75vh"
        >
          <!-- Track 6 7 8 9 -->
          <gmap-marker
            v-for="(item, i) in live"
            :key="i"
            :icon="getIcon(item.current_status)"
            @click="openWindow(item, i)"
            :position="{
              lat: item.point.coordinates[1],
              lng: item.point.coordinates[0],
            }"
          >
            <gmap-info-window
              @closeclick="window_open = null"
              :opened="window_open == i"
            >
              <div class="p-3 space-y-3">
                <span class="flex items-center font-medium"
                  ><feather-icon icon="UserIcon" svgClasses="h-5 w-5 mr-3" />{{
                    item.driver.name
                  }}</span
                >
                <span class="flex items-center font-medium"
                  ><feather-icon
                    icon="MapPinIcon"
                    svgClasses="h-5 w-5 mr-3 text-success"
                  />{{ item.country }}
                  <a
                    :href="`https://www.google.com/maps?q=${item.point.coordinates[1]},${item.point.coordinates[0]}`"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <feather-icon
                      icon="ExternalLinkIcon"
                      svgClasses="h-5 w-5 ml-3"
                    />
                  </a>
                </span>
                <p class="text-sm flex items-center">
                  <feather-icon icon="ClockIcon" svgClasses="h-5 w-5 mr-3" />
                  {{ timeAgo(item.created_date) }}
                </p>
                <p class="my-4">Odometer: {{ item.odometer }}</p>
                <div class="mt-5">
                  <router-link
                    :to="'/driver/' + item.id"
                    class="mt-6 underline"
                  >
                    View trackings
                  </router-link>
                </div>
              </div>
            </gmap-info-window>
          </gmap-marker>
        </gmap-map>
      </div>
      <!-- <vs-button @click="active=!active" color="primary" type="filled" class="ml-6">Open Sidebar</vs-button> -->
      <vs-sidebar
        style="max-width: 300px !important"
        :hidden-background="true"
        color="primary"
        class="sidebarx sidebarpage sidebar-demo-parent bordered-sidebar"
        click-not-close
        spacer
        v-model="active"
      >
        <component
          :is="scrollbarTag"
          class="scroll-area--bordered-sidebar"
          ref="verticalNavMenuPs"
          @ps-scroll-y="psSectionScroll"
          @scroll="psSectionScroll"
          :settings="settings"
        >
          <div class="p-4 pt-2">
            <vs-input
              type="search"
              icon-no-border
              label-placeholder="Search by driver name"
              class="w-full"
            >
            </vs-input>
          </div>
          <div class="lists" v-if="live">
            <div class="list" v-for="(item, i) in live" :key="i">
              <div class="header">
                <router-link
                  class="text-black hover:text-primary text-xl"
                  :to="'/driver/' + item.id"
                >
                  <strong>{{ item.truck.license_plate_num }}</strong>
                </router-link>
                <feather-icon
                  icon="ShareIcon"
                  svgClasses="h-4 w-4 ml-3 hover:text-danger"
                  @click="activePrompt2 = true"
                />
                <vs-button
                  color="primary"
                  @click="$router.push('/driver/' + item.id)"
                  type="filled"
                  >{{ item.speed }} MPH</vs-button
                >
              </div>
              <div
                class="bottom space-y-1 mt-4"
                style="display: flex; flex-direction: column"
              >
                <span class="flex items-center text-sm"
                  ><feather-icon
                    icon="MapPinIcon"
                    svgClasses="h-5 w-5 mr-3 text-success"
                  />{{ item.country }}
                  <a
                    :href="`https://www.google.com/maps?q=${item.point.coordinates[1]},${item.point.coordinates[0]}`"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <feather-icon
                      icon="ExternalLinkIcon"
                      svgClasses="h-5 w-5 ml-3"
                    />
                  </a>
                  <feather-icon
                    icon="CopyIcon"
                    @click="
                      doCopy(
                        `${item.point.coordinates[1]} ${item.point.coordinates[0]}`
                      )
                    "
                    svgClasses="h-5 w-5 ml-3 text-primary"
                  />
                </span>
                <div
                  class="space-y-1"
                  @click="$router.push('/driver/' + item.id)"
                >
                  <span class="flex items-center"
                    ><feather-icon
                      icon="UserIcon"
                      svgClasses="h-5 w-5 mr-3"
                    />{{ item.driver.name }}
                  </span>
                  <div class="flex items-center gap-4">
                    <span class="flex items-center"
                      >Fuel level: {{ item.fuel_level }}%
                    </span>
                    <span class="flex items-center"
                      >Oil level: {{ item.oil_level }}%
                    </span>
                  </div>
                  <span class="flex items-center font-medium"
                    >Started:
                    {{ $dayjs(item.created_at).format("DD-mm-YYYY, hh:mm A") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </component>
      </vs-sidebar>
      <vs-prompt :active.sync="activePrompt2">
        <div class="con-exemple-prompt">
          <vs-input
            label="Order # *"
            v-model="valMultipe.value1"
            class="mt-4 mb-2 w-full"
          />
          <vs-input
            label="Email(s) *"
            v-model="valMultipe.value2"
            class="mt-2 w-full"
          />
          <span class="mt-2 w-full">For *</span>
          <div style="display: flex; font-size: 19px">
            <vs-checkbox v-model="valMultipe.value3" id="check" />
            <label for="check"> 24 </label>
          </div>
          <div style="display: flex; font-size: 19px">
            <vs-checkbox v-model="valMultipe.value3" id="check2" />
            <label for="check2"> 48 </label>
          </div>
          <div style="display: flex; font-size: 19px">
            <vs-checkbox v-model="valMultipe.value3" id="check3" />
            <label for="check3"> 72 </label>
          </div>
          <div style="display: flex; font-size: 19px; align-items: center">
            <vs-checkbox v-model="valMultipe.value3" id="check4" />
            <vs-input for="check4" style="width: 40px; padding: 0"></vs-input>
            <span class="ml-2">Hours</span>
          </div>
        </div>
      </vs-prompt>
    </div>
  </vx-card>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import rectangle_icon from "@/assets/images/map-icons/rectangle_icon.svg";
import circle_icon from "@/assets/images/map-icons/circle_icon.svg";
import arrow_icon from "@/assets/images/map-icons/arrow_icon.svg";
import { gmapApi } from "vue2-google-maps";
export default {
  data() {
    return {
      dataFetched: false,
      connection: null,
      activePrompt2: false,
      active: false,
      valMultipe: {
        value1: "",
        value2: "",
        value3: "",
      },
      value1: "",
      center: { lat: 44.7353655, lng: 99.882813 },
      zooom: 3,
      infoContent: "",
      window_open: false,
      showShadowBottom: false,
      infoWindow: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: { width: 0, height: -35 },
      },
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      // options:{
      //               mapTypeControlOptions: {
      // //   style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      //   position: google.maps.ControlPosition.BOTTOM_LEFT,
      // },
      // }
    };
  },
  computed: {
    live() {
      return this.$store.state.event.short;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  watch: {
    dataFetched(val) {
      if (this.live.length) {
        this.initMap();
      }
    },
  },
  methods: {
    openWindow(item, index) {
      this.window_open = index;
    },
    getIcon(status) {
      if (status == "OFF" || status == "SLEEP" || status == "LOGIN") {
        return rectangle_icon;
      } else if (status == "DRIVING") {
        return arrow_icon;
      } else {
        return circle_icon;
      }
    },
    psSectionScroll() {
      const scroll_el =
        this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0;
    },
    initMap() {
      const coordinates = this.live.map((x) => x.point.coordinates);
      const bounds = new window.google.maps.LatLngBounds();
      for (let i = 0; i < coordinates.length; i++) {
        bounds.extend({ lat: coordinates[i][1], lng: coordinates[i][0] });
      }
      this.$refs.map.fitBounds(bounds);
    },
    timeAgo(date) {
      const newDate = new Date(date);
      const seconds = Math.floor((new Date() - newDate) / 1000);
      let interval = Math.floor(seconds / 31536000);

      if (interval > 1) {
        return `${interval} years ago`;
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return `${interval} months ago`;
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return `${interval} days ago`;
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return `${interval} hours ago`;
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return `${interval} minutes ago`;
      }
      return `${Math.floor(seconds)} seconds ago`;
    },
    doCopy: function (message) {
      const vs = this.$vs;
      this.$copyText(message).then(
        function (e) {
          vs.notify({
            text: "Copied",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        },
        function (e) {
          vs.notify({
            text: "Can not copy",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
          console.log(e);
        }
      );
    },
  },

  components: {
    VuePerfectScrollbar,
  },
  async created() {
    this.connection = new WebSocket(
      `${
        process.env.VUE_APP_SOCKET
      }/observe/trucks/?token=${localStorage.getItem("access")}`
    );
    let self = this;
    this.connection.onmessage = (event) => {
      let data = JSON.parse(event.data);
      self.$store.commit("event/SET_LiveShort", data.datas);
      if (!this.dataFetched) {
        this.dataFetched = true;
      }
    };
    this.connection.onclose = function (event) {
      if (event.wasClean) {
        console.log(
          event,
          `[close] Connection closed cleanly, code=${event.code} reason=${event}`
        );
      } else {
        console.log("[close] Connection died");
      }
    };
  },
  mounted() {},
};
</script>
<style scoped>
.list {
  padding: 7px;
  border-bottom: 1px solid darkgray;
  border-top: 1px solid darkgray;
  cursor: pointer;
}
.list:hover {
  background: #ffeced;
}
.vs-button {
  padding: 0.5rem 1rem !important;
  float: right;
  font-size: 11px;
  font-weight: 700;
}
.feather-arrow-left {
  margin-left: 8px;
  height: 102px;
  width: 35px;
}
.feather-arrow-right {
  margin-left: 8px;
  height: 102px;
  width: 35px;
}
.vuesax-app-is-ltr .vs-sidebar {
  left: 0;
  max-width: 300px !important;
}
</style>
<style lang="scss" scoped>
.vs-content-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 2010;
    width: 350px;
    max-width: 90vw;
  }
}
.scroll-area--bordered-sidebar {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: 100%;

  &:not(.ps) {
    overflow-y: auto;
  }
}
.dropdown-login .cursor {
  padding: 10px !important;
  cursor: pointer;
}
.vs-input {
  &--icon {
    font-size: 1.8rem !important;
  }
}
</style>
